import PropTypes from "prop-types"
import { Alert } from "antd"
import { useTranslation } from "react-i18next"
import { BILLING_STANDING, CONNECTION_STATUS } from "constants/powertranz"
import { getPowerTranzErrorMessage } from "helpers/powertranz"

// One message for the account's current state, as the API reports it.
const getStateMessage = (account, t) => {
  if (!account.isEligible) return { type: "info", message: t("powertranz.settings.state.not_eligible") }
  switch (account.connectionStatus) {
    case CONNECTION_STATUS.PENDING_VERIFICATION:
      return { type: "warning", message: t("powertranz.settings.state.pending_verification") }
    case CONNECTION_STATUS.INVALID:
      return {
        type: "error",
        message: t("powertranz.settings.state.invalid"),
        // last_verification_error is a code (invalid_credentials, hosted_page_not_found, ...)
        description: account.lastVerificationError ? getPowerTranzErrorMessage(t, account.lastVerificationError) : undefined
      }
    case CONNECTION_STATUS.DISCONNECTED:
      return { type: "info", message: t("powertranz.settings.state.disconnected") }
    case CONNECTION_STATUS.ACTIVE: {
      const isSuspended = account.billingStanding === BILLING_STANDING.SUSPENDED
      if (isSuspended || (account.isPayableKnown && !account.isPayable)) {
        return {
          type: "warning",
          message: t("powertranz.settings.state.sales_disabled"),
          description: isSuspended ? t("powertranz.settings.suspended") : undefined
        }
      }
      // Without is_payable from the API we can confirm the connection, not client availability.
      if (!account.isPayableKnown) return { type: "success", message: t("powertranz.settings.state.connected") }
      return { type: "success", message: t("powertranz.settings.state.ready") }
    }
    default:
      return null
  }
}

const StateAlert = ({ account }) => {
  const { t } = useTranslation()
  const state = getStateMessage(account, t)
  if (!state) return null
  return <Alert showIcon type={state.type} message={state.message} description={state.description} />
}

StateAlert.propTypes = {
  account: PropTypes.shape({
    isEligible: PropTypes.bool,
    isPayable: PropTypes.bool,
    isPayableKnown: PropTypes.bool,
    connectionStatus: PropTypes.string,
    billingStanding: PropTypes.string,
    lastVerificationError: PropTypes.string
  }).isRequired
}

export default StateAlert
